import useHttpProvider from "@/common/hooks/use-http";
import { notifyError } from "@/components/ui/sonner";
import { useEffect, useState } from "react";
import * as LegalInformationServices from "../services/legal-information";

function usePrivacyPolicy() {
	const { http } = useHttpProvider();

	const [content, setContent] = useState<string>("");

	const getPrivacyPolicy = async () => {
		try {
			const response = await LegalInformationServices.getPrivacyPolicy(http);
			setContent(response.content);
		} catch {
			notifyError("Privacy Policy", "Failed to get Privacy Policy");
		}
	};

	useEffect(() => {
		getPrivacyPolicy();
	}, []);

	return {
		content,
	};
}

export default usePrivacyPolicy;
